module.exports = {
    "language": {
        "name": "Türkçe",
        "code": "tr-TR",
        "codeShort": "tr"
    },
    "common": {
        "acceptAgbText": "Burada, <1>AGBs</1> okuduğumu ve bunları kabul ettiğimi onaylıyorum.",
        "dataProtection": "Gizlilik",
        "imprint": "İletişim Bilgileri",
        "administration": "Yönetim",
        "settings": "Ayarlar",
        "settingsDesc": "Ayarlarınızı Düzenleyin",
        "logoAlt": "3m5 Logo",
        "navLabelExampleForm": "Örnek",
        "navDescExampleForm": "Örnek Açıklama",
        "profileUpdateSuccessModalText": "Profil başarıyla güncellendi. \nLütfen tekrar giriş yapın",
        "passwordResetSuccessModalText": "Şifre başarıyla sıfırlandı. \nLütfen tekrar giriş yapın",
        "navLabelDashboard": "Pano",
        "navDescDashboard": "Ana Sayfa",
        "navLabelBusiness": "Şirket",
        "navDescBusiness": "Şirket",
        "navLabelUser": "Kullanıcı",
        "navDescUser": "Kullanıcı",
        "navLabelInviteColleagues": "Arkadaşlarını Davet Et",
        "navHeaderInviteColleagues": "SAF-HOLLAND I.Q. PORTAL'a meslektaşlarınızı davet edin",
        "navDescInviteColleagues": "Arkadaşınızın bilgilerini girin",
        "navLabelEmpolis": "Bilgi Merkezi",
        "navDescEmpolis": "Tüm belgeler tek bir bakışta",
        "navLabelPod": "POD",
        "navDescPod": "\"Parts On Demand\" adlı yedek parça mağazamız",
        "navLabelServiceReportOnline": "Servis Raporu",
        "navDescServiceReportOnline": "Garanti talepleri için iletişim formu",
        "navLabelTrainings": "Eğitim videoları",
        "navDescTrainings": "Öğrenmeler",
        "navLabelSpareAxleRequest": "Yedek Eksen Talebi",
        "navHeaderSpareAxleRequest": "Yedek Eksen Talebi",
        "navDescSpareAxleRequest": "Hızlı ve kolay bir şekilde hedefe ulaşın. Yedek eksen talep formu.",
        "headSpareAxleRequest": "Hızlı ve kolay bir şekilde hedefe ulaşın. Yedek eksen talep formu.",
        "register": "Oturum Aç",
        "salutation": "Hitap",
        "firstName": "İsim",
        "participatingCompany": "Katılan Firma",
        "courseName": "Kurs adı",
        "attendeesName": "Katılımcı Adı",
        "streetNr": "Sokak, No.",
        "surname": "Soyadı",
        "eMail": "E-posta adresi",
        "street": "Sokak",
        "country": "Ülke",
        "zip": "Posta Kodu",
        "city": "Şehir",
        "phone": "Telefon",
        "phoneNr": "Telefon numarası",
        "businessSegment": "İş alanı",
        "customerNumber": "Müşteri numarası",
        "ustIdNr": "Katma değer vergisi kimlik numarası",
        "tryAgain": "Tekrar deneyin",
        "editAzureProfile": "Azure Profili Düzenle",
        "streetAndNumber": "Sokak ve Bina Numarası",
        "companyName": "Şirket Adı",
        "vatId": "vergi numarası",
        "partsOnDemand": "POD",
        "reklamation": "Hizmet Raporu",
        "knowledgePortal": "Bilgi Merkezi",
        "onlineForm": "Çevrimiçi Form",
        "serviceTeam": "Hizmet Ekibi",
        "misterAbbreviation": "Bey",
        "missusAbbreviation": "Kadın",
        "doctorAbbreviation": "Dr.",
        "professorAbbreviation": "Prof.",
        "inviteColleague": "Arkadaşlarını Davet Et",
        "submitInviteInviteColleagueSuccess": "Meslektaş daveti başarılı",
        "submitInviteInviteColleagueFailure": "Formu gönderirken bir hata oluştu. Lütfen birkaç dakika içinde tekrar deneyin.",
        "submitInviteInviteColleagueFailure_UserExists": "Kullanıcı davet edilemez çünkü e-posta adresi sistemde zaten alınmış.",
        "navLabelRegistrationCourse": "Yüz Yüze Eğitime Kayıt",
        "navHeaderRegistrationCourse": "Yüz yüze eğitime kayıt",
        "axleBody": "Aks gövdesi",
        "completeAxle": "Tam Eksen",
        "completeAggregate": "Tam Agregat",
        "serialNumber": "Seri numarası",
        "axleComponent": "Hangi bileşeni değiştirmek istersiniz?",
        "optionalInfoText": "Ek Bilgiler",
        "contactDetails": "İletişim Bilgileri",
        "axleDetails": "Aks verileri",
        "component": "Bileşen",
        "optionalInfo": "Ek Bilgiler",
        "navTrainings": "Eğitimler",
        "navLabelRegistration": "Kayıt",
        "navDescRegistration": "Kayıt",
        "step1contactDetails": "1. İletişim Bilgileri",
        "step2axleDetails": "2. Aks Verileri",
        "step3Summary": "3. Özet",
        "submitRegistrationCourseSuccess": "Kayıt başarılı",
        "submitRegistrationCourseFailure": "Kayıt başarısız oldu",
        "registrationCourseHeader": "Yüz Yüze Eğitim Kaydı",
        "registrationCourseSubHeader": "Bilgilerinizi girin",
        "registrationCourseDescription": "* ile işaretlenmiş tüm alanlar zorunlu alanlardır ve göndermek için doldurulmalıdır. Eğitimler, ilgili zaman noktasında geçerli olan Coronaregeln'e göre gerçekleştirilir.",
        "registrationCourseInputLabelCourseName": "Kurs adı",
        "registrationCourseInputLabelCompanyName": "Katılan Firma",
        "registrationCourseInputLabelStreetNr": "Sokak, No",
        "registrationCourseInputLabelZipCity": "Posta Kodu, Yer",
        "registrationCourseInputLabelPhoneNr": "Telefon",
        "registrationCourseInputLabelEmail": "E-posta adresi",
        "registrationCourseInputLabelAttendeesName": "Katılımcı {{number}} İsmi",
        "registrationCourseInputLabelAgbAccepted": "<1>Genel Katılım Koşulları.</1>'nı kabul ediyorum.",
        "registrationCourseButtonLabelRegister": "Oturum Aç",
        "registrationCourseCoronaInfo": "Okullar, o anda geçerli olan Corona kurallarına göre gerçekleştirilir",
        "navLabelAcademy": "Akademi",
        "academyPageHeadline": "SAF-HOLLAND AKADEMİ",
        "academyText1": "Ürünlerimizi tanımak, bilgilerinizi tazelemek veya derinleştirmek istiyorsanız, tam olarak doğru yerdesiniz. SAF-HOLLAND Akademi Portalımızda, tüm ürün portföyümüz için temel eğitimlerin yanı sıra, özel ürünler ve konular için uzmanlaşmış eğitimler bulabilirsiniz. İster çevrimiçi, ister yerinde veya SAF-HOLLAND Akademimizde, burada herkes için bir şeyler var.",
        "academyText2": "SAF-HOLLAND eğitimleri, tüm ürün portföyü için servis ve yedek parça alanındaki temel konuları ve belirli ürünler için uzmanlık içeriklerini kapsar. Eğitimlerimiz pratikte kendini kanıtlamıştır ve sadece teknik bilgi değil, aynı zamanda pratik deneyimler de sunar, bu da katılımcılar için gerçek bir değer oluşturur.",
        "toAcademy": "Kayıt Ol",
        "myProfile": "Profilim",
        "dashboardPageHeadline": "SAF HOLLAND I.Q. PORTAL'ına hoş geldiniz",
        "dashboardTextHeadline": "SAF-HOLLAND I.Q. PORTAL: Tek bir tıklamayla Akıllı Kalite.",
        "dashboardText1": "Yedek parça siparişi veya bir şikayet hakkında veri, belge veya bilgi mi arıyorsunuz? Burada, pratik tam metin arama ve akıllı sonuç gösterimi ile hızlı ve kişiye özel filtrelenmiş bir hizmet kalitesi bulacaksınız - bir akıllı online platformda.",
        "dashboardText2": "Hedefe daha hızlı ulaşın. Knowledge Center'ın akıllı arama fonksiyonu, aradığınız konuyu PDF belgelerinde ve resimlerde de bulur. Böylece tüm SAF-HOLLAND ürünlerine ve POD'a ait tam teknik belgelere hızlı bir şekilde erişim sağlarsınız.",
        "dashboardText3": "Ancak şikayetleriniz de burada iyi bir şekilde ele alınır: Birkaç tıklama ile çevrimiçi bir form aracılığıyla hizmet ekibimize bir şikayet gönderebilirsiniz.",
        "serviceReportOnlinePageHeadline": "Servis Raporu",
        "serviceReportOnlineTextHeadline": "Şikayetleri zamanında iletmek.",
        "serviceReportOnlineText1": "Ürün teslimatında bir kusur mu buldunuz ya da teknik bir problem mi yaşıyorsunuz? Tüm endişelerinizi hızlıca giderir ve şikayetlerinizle ilgileniriz!",
        "serviceReportOnlineText2": "Servis Raporunda hızlı yardım bulabilirsiniz: Şikayetinizi belirtilen formda belirtin, iletişim bilgilerinizi girin ve belgeyi basit ve güvenli bir şekilde doğrudan servis ekibimize gönderin. Burada durum hızlı bir şekilde incelenir ve hasar durumunuz hakkında da hızlı bir geri bildirim alırsınız.",
        "serviceReportOnlineImgLabel": "Merhaba. Ben küçük bir körlük metniyim. Ve bu durumda olduğumu düşünebildiğim kadar uzun süre. Bir körlük metni olmanın ne anlama geldiğini anlamak kolay olmadı: Hiçbir anlam ifade etmiyorsunuz.",
        "startRequest": "Talep başlat",
        "empolisPageHeadline": "Bilgi Merkezi",
        "empolisTextHeadline": "Teknik konuları hızlıca bulun.",
        "empolisText1": "SAF-HOLLAND'ın Bilgi Merkezi, 24/7 güncel bilgi almak isteyen herkes için tam da doğru bilgi yönetim sistemidir. Burada, tüm ürün grupları ve aksesuarlar hakkında birçok belge ve haber bulabilirsiniz - farklı bilgi formatlarında düzenli bir şekilde sıralanmış. Belirli bir kullanıcı kılavuzu arıyor, bir teknolojiye mi girmek istiyor veya bir ürün hakkında detay mı bulmak istiyorsunuz?",
        "empolisText2": "Bilgi Merkezi'nde farklı ürün grupları ve bilgi türleri arasından seçim yapabilir ve böylece aramanızı daraltabilirsiniz. Akıllı tam metin arama özelliği sayesinde ayrıca doğrudan herhangi bir anahtar kelime veya problem durumu girebilirsiniz. Sistem sizi otomatik olarak ilgili belgeye veya bulunan yanıta yönlendirir. Tarafınızdan tanımlanan arama terimleri, bulunan metinde bile işaretlenir. Menüde ayrıca Bilgi Merkezinizi daha da kişiselleştirebilir ve örneğin ilginç kaynaklarda yer imi ekleyebilir, haberleri doğrudan alabilir veya arama geçmişinizi görebilirsiniz.",
        "empolisImgLabel": "Merhaba. Ben küçük bir körlük metniyim. Ve bu durumda olduğumu düşünebildiğim kadar uzun süredir. Bir körlük metni olmanın ne anlama geldiğini anlamak kolay olmadı: Hiçbir anlam ifade etmiyorsunuz.",
        "toKnowledgePortal": "Bilgi Merkezi'ne",
        "partsOnDemandPageHeadline": "POD (Parts on Demand)",
        "partsOnDemandTextHeadline": "Her zaman yedek parça siparişi verin.",
        "partsOnDemandText1": "SAF-HOLLAND ürününüz için belirli bir yedek parça mı arıyorsunuz ve doğru olanı hızlıca sipariş etmek mi istiyorsunuz? O zaman en iyi hedefe buradan ulaşırsınız! POD (Parts On Demand) portal alanında, sadece tüm mevcut yedek parçalar hakkında ayrıntılı bilgiler bulmakla kalmaz, seçiminizi doğrudan müşteri platformu üzerinden de sipariş edebilirsiniz.",
        "partsOnDemandText2": "Bir yedek parça ne kadar hızlı temin edilirse, işletmenizin durması o kadar iyi engellenir. Hızlı bir şekilde tekrar harekete geçmenizin ne kadar önemli olduğunu biliyoruz ve yedek parça lojistiğimizi bu doğrultuda optimize ettik. Bu yüzden artık ihtiyaç duyduğunuz parçayı doğrudan çevrimiçi olarak arayabilir ve POD üzerinden sipariş verebilirsiniz. POD ayrıca size tüm ürünler ve ürün grupları hakkında bir genel bakış sağlar - burada yedek parçaları rahatça arayabilir ve daha fazla bilgi bulabilirsiniz.",
        "partsOnDemandImgLabel": "Merhaba. Ben küçük bir körlük metniyim. Ve bu kadar uzun süredir düşünebildiğim kadarıyla. Bir körlük metni olmanın ne anlama geldiğini anlamak kolay olmadı: Hiçbir anlam ifade etmiyorsunuz.",
        "toPodPortal": "POD Portalına",
        "trainingsPageHeadline": "Eğitim videoları",
        "trainingsTextHeadline1": "Temel Eğitim - Ürün Genel Bakışı I - Genel Bilgiler ve Eksenler",
        "trainingsTextHeadline2": "Temel Eğitim - Ürün Genel Bakış II - Disk Frenler",
        "trainingsTextHeadline3": "Temel Eğitim - Ürün Genel Bakışı III - Şasi Sistemleri ve Aksesuarlar",
        "profileUpdateSuccess": "Profil başarıyla güncellendi.\nLütfen tekrar giriş yapın.",
        "passwordResetSuccess": "Şifre başarıyla sıfırlandı.\nLütfen yeni şifrenizle giriş yapın.",
        "infoNetworkProblems1": "Sayın müşterimiz, ağ sorunları nedeniyle şu anda ne yazık ki e-posta ve telefon numarası ile çok sınırlı bir şekilde ulaşılabilir durumdayız.\nLütfen mobil numaranızı kullanarak dış hizmetler çalışanınıza başvurun. \nBu telefon numarasını bu web sitesinde de bulabilirsiniz ",
        "infoNetworkProblemsLink": "https://safholland.com/int/tr/",
        "infoNetworkProblems2": "Anlayışınız için teşekkür ederiz",
        "FLEET": "Filo",
        "VEHICLE_DEALER": "Araç bayisi",
        "WORKSHOP": "Atölye",
        "PARTS_DEALER": "Yedek parça satıcısı",
        "softwarePageHeadline": "Yazılım dağıtımı",
        "softwareTextHeadline": "Çaba gerektirmeyen indirme",
        "softwareText1": "Dijital inovasyonlar dünyasında, kaliteli yazılıma erişim kritik bir rol oynar. I.Q. Portalımızda, minimum çaba ile birinci sınıf yazılımları indirip yüklemenizi sağlayan özel bir alan oluşturduk. Sadece birkaç tıklama ile güçlü uygulamalarla dolu bir dünya sizin olur.",
        "softwareText2": "Aradığınız yazılımı bulduğunuzda, indirmeyi başlatmak için tek bir tıklama yeterlidir. Sistemimiz, gereken dosyaları hızlı bir şekilde almanızı sağlamak için verimli bir şekilde çalışır, uzun bekleme süreleri olmadan.",
        "softwareText3": "Yükleme, indirme kadar basittir. Yazılımı hızlı ve sorunsuz bir şekilde yüklemek için ekranda gösterilen talimatları takip edin.",
        "toSoftware": "Yazılıma Git",
        "navLabelSoftware": "Yazılım"
    },
    "form": {
        "submitForm": "Formu Gönder",
        "newUserFormStep1Label": "Kullanıcı",
        "newUserFormStep2Label": "Şirket",
        "newUserFormStepSuccessHeading": "Kayıt başarılı.",
        "newUserFormStepSuccessText": "Bir yönetici tarafından etkinleştirildiğinizde, müşteri portalını kullanabilirsiniz.",
        "newUserFormStep1Notification": "Bu veriler Azure profilinizden gelmektedir.",
        "vehicleManufacturer": "Araç üreticisi",
        "workshop": "Atölye",
        "partsDealer": "Parça satıcısı",
        "fleetOrDispatchDepartment": "Filo/Nakliye",
        "salutationSIR": "Bey",
        "salutationMADAM": "Bayan",
        "salutationDR": "Dr",
        "salutationPROF": "Prof",
        "acceptPrivacyPolicyText": "Burada, <1>Gizlilik Politikası</1> 'nı okuduğumu ve kabul ettiğimi onaylıyorum.",
        "acceptPrivacyPolicyInfo": "Devam etmek için gizlilik politikasını kabul etmelisiniz.",
        "next": "Devam",
        "back": "Geri",
        "save": "Kaydet",
        "submit": "Gönder",
        "reset": "sıfırla",
        "changeName": "İsim Değiştir",
        "changePassword": "Şifre Değiştir",
        "spareAxleRequestFormStep1Label": "İletişim Bilgileri",
        "spareAxleRequestFormStep2Label": "Aks verileri",
        "spareAxleRequestFormStep3Label": "Özet",
        "spareAxleRequestFormStepSuccessHeading": "Yedek aks talebi başarıyla gönderildi",
        "spareAxleRequestFormStepSuccessText": "Yedek aks talebiniz başarıyla gönderildi",
        "spareAxleRequestFormStepSuccessButton": "Daha Fazla Soru Sor",
        "linkNeedHelp": "Yardıma mı ihtiyacınız var?",
        "close": "Kapat"
    },
    "error": {
        "unknownErrorHasOccurred": "Bilinmeyen bir hata oluştu",
        "logOutFailed": "Oturum Kapatma Başarısız",
        "pageNotFound": "Sayfa bulunamadı",
        "companyNameNotFound": "Şirket adı bulunamadı",
        "appInitFailed": "Uygulama yüklenemedi. Lütfen daha sonra tekrar deneyin.",
        "inputInvalid": "geçersiz giriş",
        "atLeastOneElementMustBeCreated": "en az 1 öğe oluşturulmalıdır",
        "theMinimumQuantityIs": "Minimum miktar {{itemCount}}'dır",
        "noOrderHasBeenPlaced": "Hiçbir sipariş verilmedi",
        "passwordsNotIdentical": "Şifre girişleri uyuşmuyor",
        "passwordToShort": "Şifre çok kısa",
        "fileUploadFailed": "Dosya yükleme başarısız oldu",
        "statusCode403": "Erişim reddedildi",
        "statusCode404": "Sunucuya ulaşılamıyor. Lütfen daha sonra tekrar deneyin.",
        "statusCode501": "Bu işlevsellik henüz mevcut değil.",
        "mandatoryField": "Zorunlu alan",
        "signInError": "Kayıt başarısız oldu. Lütfen birkaç dakika sonra tekrar deneyin.",
        "signOutError": "Abonelik iptali başarısız oldu. Lütfen yöneticiye başvurun.",
        "editProfileError": "Profil güncellenirken bir hata oluştu. Lütfen yöneticiye başvurun.",
        "invalidMailAddress": "geçersiz e-posta adresi",
        "fetchUserError": "Kullanıcı verileri alınırken bir hata oluştu. Lütfen bir yöneticiye başvurun.",
        "zipErrorMessage": "Bir posta kodunun tam olarak 5 hanesi vardır",
        "emailErrorMessage": "Geçerli bir e-posta adresi yok",
        "phoneErrorMessage": "Geçerli bir telefon numarası değil",
        "serialNumberErrorMessage": "Bir seri numarasının tam olarak 11 hanesi olmalıdır",
        "cantDelete": "Silme işlemi sırasında bir hata oluştu. Nesne hala diğer nesnelerle ilişkili olabilir.",
        "cantUpdateNotFound": "Veriler kaydedilemedi. Muhtemelen artık mevcut değiller.",
        "cantUpdate": "Veriler kaydedilemedi. Muhtemelen bir anahtar özelliğe zaten var olan bir değer atadınız.",
        "lackingPermission": "İstediğiniz değişiklikleri yapmaya yetkili değilsiniz."
    },
    "link": {
        "dataProtection": "https://safholland.com/int/en/privacy-policy/#c4160",
        "imprint": "https://safholland.com/int/en/imprint-1",
        "course1": "https://safholland.com/de/en/events/event/advanced-training-course-23-01-2024",
        "course2": "https://safholland.com/de/en/events/event/haldex-ebs-training-06-02-2024",
        "course3": "https://safholland.com/de/en/events/event/system-training-courses-brake-technology-20-02-2024",
        "course4": "https://safholland.com/de/en/events/event/system-training-steering-axles-09-04-2024",
        "course5": "https://safholland.com/de/en/events/event/haldex-ebs-training-23-04-2024",
        "course6": "https://safholland.com/de/en/events/event/advanced-training-course-14-05-2024",
        "course7": "https://safholland.com/de/en/events/event/haldex-ebs-training-04-06-2024",
        "course8": "https://safholland.com/de/en/events/event/haldex-ebs-training-20-08-2024",
        "course9": "https://safholland.com/de/en/events/event/system-training-driven-axle-saf-intra-cd-trak-08-10-2024",
        "courseOverview": "https://safholland.com/de/en/aftersales/trainings",
        "pod": "https://pod.safholland.de/shop/app?forcerestart=true",
        "course10": "https://safholland.com/de/en/events/event/advanced-training-course-15-10-2024",
        "course11": "https://safholland.com/de/en/events/event/haldex-ebs-training-22-10-2024",
        "course12": "https://safholland.com/de/en/events/event/haldex-ebs-training-12-11-2024",
        "course13": "https://safholland.com/de/en/events/event/system-training-courses-brake-technology-26-11-2024"
    },
    "course": {
        "linkToCourse": "Eğitime Bağlantı",
        "course1": "23.01. Bakım (İleri Eğitim) SAF-HOLLAND Akademi Aschaffenburg",
        "course2": "06. - 07.02. Elektronik Fren Sistemi (EBS) SAF-HOLLAND Akademisi Aschaffenburg",
        "course3": "20.02. SAF-HOLLAND Akademi Aschaffenburg Fren Teknolojisi",
        "course4": "09.04. SAF-HOLLAND Akademisi Aschaffenburg Direksiyon Aksları",
        "course5": "23. - 24.04. Elektronik Fren Sistemi (EFS) Tuttlingen GmbH Mesleki Eğitim Merkezi",
        "course6": "14.05. Bakım (İleri Eğitim) SAF-HOLLAND Akademisi Aschaffenburg",
        "course7": "04. - 05.06. Elektronik Fren Sistemi (EFS) Frank Fahrzeugbau GmbH, Markranstädt",
        "course8": "20. - 21.08. Elektronik Fren Sistemi (EBS) Münster Zanaatkarlar Odası",
        "course9": "08.10. SAF-HOLLAND Akademisi Aschaffenburg'da Tahrikli Akslar",
        "course10": "15.10. Bakım (İleri Eğitim) SAF-HOLLAND Akademisi Aschaffenburg",
        "course11": "22. - 23.10. Elektronik Fren Sistemi (EBS) Berger Kamyon Servisi GmbH, AT-Wörgl",
        "course12": "12. - 13.11. Elektronik Fren Sistemi (EBS) SAF-HOLLAND Akademisi Aschaffenburg",
        "course13": "26.11. SAF-HOLLAND Academy Aschaffenburg Fren Teknolojisi"
    }
};